import {
  Button,
  ICONS,
  PLATFORM_THEME_COLORS,
  Popover,
  Icon,
  Typography,
} from '@thinknet-gmbh/platform-common-ui';

import { ButtonLabelContainer, StyledButtonLine } from './dropdown-button.styles';
import { ITableMenuElement } from '@thinknet-gmbh/platform-common-ui/dist/components/view-blocks/popover/table-menu/table-menu.interfaces';

const DropdownButton = ({
  title,
  icon,
  listItem,
}: {
  title: string;
  icon?: string;
  listItem: ITableMenuElement[];
}) => {
  return (
    <Popover trigger={'click'} placement="bottom" elements={listItem}>
      <Button
        type="primary"
        icon={icon || ICONS.plus}
        iconColor={PLATFORM_THEME_COLORS.primary.white}
      >
        <ButtonLabelContainer>
          <Typography color={PLATFORM_THEME_COLORS.primary.white}>{title}</Typography>
          <StyledButtonLine />
          <Icon
            icon={ICONS.chevronDown}
            color={PLATFORM_THEME_COLORS.primary.white}
            leftMargin={false}
            size={16}
          />
        </ButtonLabelContainer>
      </Button>
    </Popover>
  );
};

export default DropdownButton;
